"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postJobInvoiceBulkPdf = void 0;
/**
 * Generate multiple job invoice PDFs and email them to the user(s)
 */
var postJobInvoiceBulkPdf = function (instance) {
    return function (body, config) {
        return instance.post("/jobs/pdf/invoice/bulk", body, config);
    };
};
exports.postJobInvoiceBulkPdf = postJobInvoiceBulkPdf;
